import { WIDGET_NAME } from '@sitegen/common/constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import { getTrackingFlowSubType } from 'utils/analytics';

export const INITIAL_ANALYTICS_DATA = {
    flowStep: 'platform selection',
    flowSubType: getTrackingFlowSubType(WIDGET_NAME.CF_REDEEM)
};

export const ANALYTICS_FLOW_EVENT_PAGE_DATA = {
    ...INITIAL_ANALYTICS_DATA,
    category: CATEGORY.DISPLAY,
    action: 'platform selection'
};

export const ANALYTICS_FLOW_EVENT_SUBMIT_CODE_DATA = {
    ...INITIAL_ANALYTICS_DATA,
    category: CATEGORY.ACTION,
    action: 'submit my code'
};
